import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getAssetUrl(url, { width = 800, quality = 80 } = {}) {
  if (!url) return ''
  const match = url.match(/(?:\/assets\/[^/]+\/|\/_assets\/)([^?#]+)/)
  if (match) {
    return `/cdn-cgi/image/width=${width},quality=${quality},format=auto/_assets/${match[1]}`
  }
  return url
}

